import chroma from 'chroma-js';
import { css, Flex, styled } from '@withjoy/joykit';

/**
 * Chrome for an inline nav that floats over the page card instead of sitting on a hero: the
 * single-page layout's StickyNavBar once scrolled, and the classic-nav interior pages of a video
 * hero whose couple keeps the video on the welcome page only (see shouldOverlayStandaloneNav).
 */
const NAV_BAR_CHROME_BACKGROUND_ALPHA = 0.8;
const NAV_BAR_CHROME_BLUR = '0.25rem';
const NAV_BAR_CHROME_PADDING_Y = '0.25rem';

export const getNavBarChromeBackgroundColor = (pageColor: string | undefined): string =>
  chroma(pageColor || '#ffffff')
    .alpha(NAV_BAR_CHROME_BACKGROUND_ALPHA)
    .css();

export const navBarChromeSurfaceStyles = (backgroundColor: string) => css`
  background-color: ${backgroundColor};
  backdrop-filter: blur(${NAV_BAR_CHROME_BLUR});
  -webkit-backdrop-filter: blur(${NAV_BAR_CHROME_BLUR});
`;

export const StyledNavBarChromeContent = styled(Flex)`
  width: 100%;
  padding-top: ${NAV_BAR_CHROME_PADDING_Y};
  padding-bottom: ${NAV_BAR_CHROME_PADDING_Y};
  justify-content: center;
`;
